import * as React from "react";
import FaqView from "../presentation/faq";
export default class FAQ extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (React.createElement(FaqView, null));
    }
}
;
//# sourceMappingURL=faq.js.map